<template>
    <DataTable
        :header="$t('listOfProposedProducts')"
        :fields="fields"
        :items="parentComponent.items"
        :loading="parentComponent.loading"
        :error="parentComponent.error"
        :total-rows="parentComponent.requestData.max"
        :current-page.sync="parentComponent.tableParams.page"
        :per-page.sync="parentComponent.tableParams.perPage"
        no-sort-reset
        no-local-sorting
    >

        <template #cell(action)="{item}">
            <ButtonIcon size="sm" :to="getItemUrl(item)">
                {{ $t('show') }}
            </ButtonIcon>
        </template>

        <template #cell(productId)="{item}">
            <b-link :to="{name: 'Offers', query: { product: item.productId }}">{{ item.productId }}</b-link>
        </template>

        <template #cell(catalogId)="{item}">
            <b-link :to="{name: 'CatalogProductsDetails', params: { id: item.catalogId }}">{{ item.catalogId }}</b-link>
        </template>

        <template #cell(categories)="{item}">
            <ul class="m-0 p-0">
                <li v-for="(categories, index) in item.categories" :key="index">
                    {{ categories.map(item => item.name).join(' > ') }}
                </li>
            </ul>
        </template>

        <template #cell(space)="{item}">
            {{ item.space.name }}
        </template>

    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'Results',
        components: {
            DataTable,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {};
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'name', label: this.$t('name') },
                    { key: 'sku', label: this.$t('sku') },
                    { key: 'ean', label: this.$t('ean') },
                    { key: 'productId', label: this.$t('aggregateId') },
                    { key: 'catalogId', label: this.$t('productId') },
                    { key: 'categories', label: this.$t('categories') },
                    { key: 'space', label: this.$t('space') },
                    { key: 'action', label: '' },
                ];
            },
        },
        methods: {
            getItemUrl(item) {
                return {
                    name: 'ProducerProductsProductsDetails',
                    params: { id: item.id, parentUrl: this.$route.params.parentUrl || this.$route.fullPath },
                    query: {},
                };
            },
        },
    };
</script>
